import React from 'react'
import { normalizeWitnessData } from '../../utilities'
import { ReviewWitness } from './ReviewWitness'

export const ReviewWitnesses = ({ values, ...props }) => {
  const witnesses = normalizeWitnessData(values, 4)
  const singleWitness = witnesses.length == 1

  return witnesses.map((witness, index) => {
    const editFieldName = `witness_first_name_${index}`
    const witnessProps = {
      ...witness,
      ...props,
      editFieldName
    }
    return (
      <section key={editFieldName}>
        {singleWitness ? <h2>Witness</h2> : <h2>Witness {index + 1}</h2>}
        <ReviewWitness {...witnessProps} />
      </section>
    )
  })
}
